import { render, staticRenderFns } from "./PartnersBlock.vue?vue&type=template&id=bc2e4aa4&"
import script from "./PartnersBlock.vue?vue&type=script&lang=js&"
export * from "./PartnersBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports